import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalFooter,
  Button,
  ModalBody,
} from "reactstrap"
import axios from "axios"
import { toast, ToastContainer } from "react-toastify"
import { Link } from "react-router-dom"
import "react-toastify/dist/ReactToastify.css"
import moment from "moment"
import Spinners from "components/Common/Spinner"
const DeleteModal = ({ isOpen, toggle, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>Are you sure you want to delete this lesson plan?</ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onConfirm}>
          Delete
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}
const Report = () => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [reports, setReports] = useState([])
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)

  const [loading, setLoading] = useState(false)
  const sid = localStorage.getItem("sid")?.replace(/"/g, "")
  const userid = localStorage.getItem("user_id")

  useEffect(() => {
    let currentDate = new Date().toISOString().split("T")[0]
    setEndDate(currentDate)

    const currentMonth = parseInt(currentDate.split("-")[1])
    const lastMonth = currentMonth - 1 || 12
    const lastMonthStr = lastMonth < 10 ? `0${lastMonth}` : lastMonth
    const lastYear =
      currentMonth === 1
        ? parseInt(currentDate.split("-")[0]) - 1
        : currentDate.split("-")[0]

    const lastDate = `${lastYear}-${lastMonthStr}-${currentDate.split("-")[2]}`
    setStartDate(lastDate)
  }, [])

  useEffect(() => {
    if (startDate && endDate) {
      getReports()
    }
  }, [startDate, endDate])

  const getReports = async () => {
    if (!startDate || !endDate) {
      toast.warning("Please select both start and end dates.")
      return
    }
    setLoading(true)

    const data = {
      sid: sid,
      staff: userid,
      startDate,
      endDate,
    }

    try {
      const response = await axios.post(
        "https://marcopolo.prisms.in/api/admin/lessonPlan/reportBydate",
        data,
        {
          headers: {
            Authorization: "#$laksdfnlknoea#$@$%^&%$",
          },
        }
      )
      if (response?.data) {
        setLoading(false)
        setReports(response.data.reverse())
      }
    } catch (error) {
      setLoading(false)
      toast.error("Failed to fetch reports.")
    }
  }

  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen)

  const confirmDelete = async () => {
    try {
      await axios.post(
        "https://topschooldev.prisms.in/rest/index.php/staff_list.json",
        {
          fun_name: "deleteLessonPlan",
          staff_id: userid,
          sid: sid,
          id: deleteId,
        }
      )
      toast.success("Lesson plan deleted successfully.")
      toggleDeleteModal()
      getReports()
    } catch (err) {
      toast.error("Failed to delete the report.")
    }
  }

  const handleDeleteClick = id => {
    setDeleteId(id)
    toggleDeleteModal()
  }

  return (
    <div className="page-content">
      <Container>
        <DeleteModal
          isOpen={deleteModalOpen}
          toggle={toggleDeleteModal}
          onConfirm={confirmDelete}
        />
        <Card>
          <CardBody>
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Lesson Plan Report
            </h1>

            <Form>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="startDate">Select Start Date</Label>
                    <Input
                      type="date"
                      id="startDate"
                      value={startDate}
                      onChange={e => setStartDate(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="endDate">Select End Date</Label>
                    <Input
                      type="date"
                      id="endDate"
                      value={endDate}
                      onChange={e => setEndDate(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>

            <Table bordered responsive hover className="mt-4">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Class</th>
                  <th>Subject</th>
                  <th>Lesson Name</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center">
                  {" "}
                  <Spinners />
                </div>
              ) : (
                <tbody>
                  {reports.length > 0 ? (
                    reports.map((report, index) => (
                      <tr key={report.id}>
                        <td>{index + 1}</td>
                        <td>{report.div_name}</td>
                        <td>{report.subject}</td>
                        <td>{report.Lessonname}</td>
                        <td>
                          {moment(report.created_date).format("DD-MM-YYYY")}
                        </td>
                        <td>
                          <Link
                            to={`/lesson-Plan`}
                            className="me-2"
                            state={{ id: report.id }}
                          >
                            <i
                              className="bx bx-show text-info fs-5"
                              style={{ cursor: "pointer" }}
                            ></i>
                          </Link>
                          <i
                            className="bx bx-trash text-danger fs-5"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDeleteClick(report.id)}
                          ></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No reports found for selected date range.
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </Table>

            <ToastContainer position="top-right" autoClose={3000} />
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default Report
